import React, { useState, useEffect, useRef, useCallback, useMemo, useContext } from 'react';
import AutosuggestComponent from '../Components/AutosuggestComponent';
import CustomInput from '../Components/CustomInput'
import ErrorBoundary from '../Components/ErrorBoundary'
import Table from 'react-bootstrap/Table';
import moment from 'moment'

export default function SubscribeModal(props) {
    const [message, setMessage] = useState("");
    const [newsubscriptionList, setNewsubscriptionList] = useState("");

    useEffect(() => {
        if (props.gridObjData.data.subscption_status == 0 || props.gridObjData.data.subscption_status == 1 || props.gridObjData.data.subscption_status == 2 || (props.gridObjData.data.subscption_status == 3 && props.gridObjData.data.OrganisationSubscriptions.length > 0)) {
            let filterSubscribeData = props.subscriptionListData.filter((obj) => parseFloat(obj.subscription_price) > 0);
            setNewsubscriptionList(filterSubscribeData)
        } else {
            setNewsubscriptionList(props.subscriptionListData)
        }
    }, [props.subscriptionListData])
    useEffect(() => {
        let currentSubscriptionStatus = "";
        if (props.gridObjData.data.subscption_status == 0) {
        } else if (props.gridObjData.data.subscption_status == 1) {
            currentSubscriptionStatus = `This hotel is currently subscribed, with the subscription period running from ${moment(props.gridObjData.data.OrganisationSubscriptions[0].subscription_start_date).format('MMMM DD, YYYY')}, to ${moment(props.gridObjData.data.OrganisationSubscriptions[0].subscription_end_date).format('MMMM DD, YYYY')}.`
        } else if (props.gridObjData.data.subscption_status == 2) {
        } else {
        }
        setMessage(currentSubscriptionStatus);

    }, [props.gridObjData])
    return (

        <div className="gridcontainer subModalContainer">
            <div className="modalinnerbody">
                <div className="innerbodydimension subscribeInner">
                    <div className='col-md-12'>
                        <div className='datePanel'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='row'>
                                        <p className='messageText'>{message}</p>
                                        <div className='col-md-12'>
                                            <div className="dropdowninnerboxContainer">
                                                <label>Plan Name <span>*</span></label>
                                                <AutosuggestComponent
                                                    handleOnChange={(e) => { props.handleChangesubscriptionList(e) }}
                                                    options={newsubscriptionList}
                                                    selectedValue={props.selectedSubscription}
                                                    name=''
                                                    isMulti={false}
                                                    placeholder={"Select subscription"}
                                                    isDisabled={props.subscriptionModalTitle == 'Extend Subscription' ? true : false}
                                                    isSearchable={true}
                                                    menuPosition="fixed"
                                                    isClearable={true}
                                                    classNamePrefix="dropdown-default"
                                                />
                                            </div>
                                        </div>
                                        {Object.keys(props.selectedSubscription).length > 0 ?
                                            <div className='col-md-12'>
                                                <Table className="tableviewdoc">
                                                    <tr>
                                                        <td>Plan Type </td>
                                                        <td>  {props.selectedSubscription.subcription_type}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Amount
                                                            <p style={{ fontSize: '11px', lineHeight: '120%', margin: '0', padding: '0px', color: '#999' }}>(Inclusive of all Taxes)</p>
                                                        </td>

                                                        <td>  {(parseFloat(props.selectedSubscription.subscription_price) + parseFloat(props.selectedSubscription.cgst_amt) + parseFloat(props.selectedSubscription.sgst_amt)).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Description</td>
                                                        <td className='descriptionText'><p>{props.selectedSubscription.subscription_details}</p></td>
                                                    </tr>
                                                </Table>
                                            </div> : null}

                                        {props.subscriptionModalTitle == 'Extend Subscription' ?
                                            <div className='col-md-12'>
                                                <fieldset className='extendBox'>
                                                    <legend><h2 className='titleEx'>Extend Time</h2></legend>
                                                    <div className='chkBoxPanel'>
                                                        <label className="radiocontainer">7 Days
                                                            <input type="radio" name="radio" checked={props.extendDays == 7 ? true : false} onChange={(e) => props.handleExtendSubscrib(e, "7")} />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                        <label className="radiocontainer">14 Days
                                                            <input type="radio" name="radio" checked={props.extendDays == 14 ? true : false} onChange={(e) => props.handleExtendSubscrib(e, "14")} />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                        <label className="radiocontainer">30 Days
                                                            <input type="radio" checked={props.extendDays == 30 ? true : false} name="radio" onChange={(e) => props.handleExtendSubscrib(e, "30")} />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </fieldset>
                                            </div>
                                            : null}

                                    </div>

                                    {Object.keys(props.selectedSubscription).length > 0 && props.subscriptionModalTitle != 'Extend Subscription' &&

                                        <div className="col-md-12 text-center topspace">
                                            <button type="button" className="modBtnSave"
                                                onClick={(e) => props.addNewSubscription()}
                                            >Pay</button>
                                            <button type="button" className="modBtnSave cancelbtn"
                                                onClick={(e) => props.closeSubscriptionModal()}
                                            >Cancel</button>
                                        </div>
                                    }
                                    {props.subscriptionModalTitle == 'Extend Subscription' &&
                                        <div className="col-md-12 text-center topspace">
                                            <button type="button" className="modBtnSave"
                                                onClick={(e) => props.addExtendSubscription()}
                                            >Extend</button>
                                            <button type="button" className="modBtnSave cancelbtn"
                                                onClick={(e) => props.closeSubscriptionModal()}
                                            >Cancel</button>
                                        </div>}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
